module.exports = __webpack_public_path__ + "ef60a4f6c25ef7f39f2d25a748dbecfe.woff";